export default __webpack_public_path__ + "static/media/warning.9f86fe88.gif";